import React, { Suspense } from 'react';
import { Redirect, Route } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IonLoading } from '@ionic/react';

import { RootState } from '../store/root-reducer';
import { routeTo } from '../store/router/router.actions';

const Login = React.lazy(() => import('../pages/login/Login'));
const Signup = React.lazy(() => import('../pages/signup/Signup'));
const ForgotPassword = React.lazy(
  () => import('../pages/forgotPassword/forgotPassword')
);
const ConfirmPassword = React.lazy(
  () => import('../pages/confirmPassword/confirmPassword')
);
const AppsPage = React.lazy(() => import('../pages/apps/apps'));

type Props = LinkDispatchProps & LinkStateProps;

class Router extends React.Component<Props> {
  private renderLoading() {
    return <IonLoading isOpen={true} />;
  }

  render() {
    return (
      <>
        <Suspense fallback={<div>{this.renderLoading()}</div>}>
          <Route
            path="/login"
            exact={true}
            render={(props) => {
              this.props.routeTo('/login');
              return <Login {...props}> </Login>;
            }}
          />
          <Route
            path="/signup"
            exact={true}
            render={(props) => {
              this.props.routeTo('/signup');
              return <Signup {...props}> </Signup>;
            }}
          />
          <Route
            path="/apps"
            exact={true}
            render={(props) => {
              this.props.routeTo('/apps');

              return !this.props.authenticated ? (
                <Redirect to="/login" />
              ) : (
                <AppsPage {...props}> </AppsPage>
              );
            }}
          />
          <Route
            path="/forgotPassword"
            exact={true}
            render={(props) => {
              this.props.routeTo('/forgotPassword');
              return <ForgotPassword {...props}> </ForgotPassword>;
            }}
          />
          <Route
            path="/confirmPassword"
            exact={true}
            render={(props) => {
              this.props.routeTo('/confirmPassword');
              return <ConfirmPassword {...props}> </ConfirmPassword>;
            }}
          />
          <Route
            exact={true}
            path="/"
            render={() => <Redirect to="/login" />}
          />
        </Suspense>
      </>
    );
  }
}

interface LinkStateProps {
  authenticated: boolean;
}

interface LinkDispatchProps {
  routeTo: (url: string) => void;
}

const mapState = (state: RootState): LinkStateProps => {
  return {
    authenticated: state.user.authenticated ? state.user.authenticated : false,
  };
};

const mapDispatchToProps = (dispatch: any): LinkDispatchProps => ({
  routeTo: bindActionCreators(routeTo, dispatch),
});

export default connect(mapState, mapDispatchToProps)(Router);
